import React from 'react';
import { CardElement, injectStripe } from 'react-stripe-elements';
import './Form.css';

class StripeForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    handleSubmit = async event => {
        const { stripe, payForReview } = this.props;
        event.preventDefault();
        const { token, error } = await stripe.createToken();
        await payForReview(token.id);
    };

    handleBlur = () => {};
    handleChange = change => {};
    handleFocus = () => {};
    handleReady = () => {};

    render() {
        const { total } = this.props;
        return (
            <form
                className="d-flex flex-column justify-content-center stripe-form mt-4"
                onSubmit={this.handleSubmit}
            >
                <CardElement
                    onBlur={this.handleBlur}
                    onChange={this.handleChange}
                    onFocus={this.handleFocus}
                    onReady={this.handleReady}
                    className="card-input"
                />
                <div className="mt-4">
                    <button className="btn stripe-button primary">Pay ${total.toFixed(2)}</button>
                </div>
            </form>
        );
    }
}

export default injectStripe(StripeForm);
